import React from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "./ImageOrderManager.scss";

function ImageOrderManager({
  images,
  onReorder,
  mainImage,
  onSetMainImage,
  onRemoveImage,
}) {
  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const reordered = Array.from(images);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);
    onReorder(reordered);
  };

  const moveImage = (index, direction) => {
    const targetIndex = index + direction;
    if (targetIndex < 0 || targetIndex >= images.length) return;
    const reordered = Array.from(images);
    const [moved] = reordered.splice(index, 1);
    reordered.splice(targetIndex, 0, moved);
    onReorder(reordered);
  };

  if (!images || images.length === 0) return null;

  return (
    <div className="image-order-manager">
      <h3 className="image-order-manager__heading">
        Gallery Images &mdash; Drag to Reorder
      </h3>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="gallery-images" direction="horizontal">
          {(provided) => (
            <div
              className="image-order-manager__grid"
              ref={provided.innerRef}
              {...provided.droppableProps}
            >
              {images.map((url, index) => (
                <Draggable key={url} draggableId={url} index={index}>
                  {(provided, snapshot) => (
                    <div
                      className={`image-order-manager__card${
                        snapshot.isDragging
                          ? " image-order-manager__card--dragging"
                          : ""
                      }`}
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <span className="image-order-manager__position">
                        {index + 1}
                      </span>
                      <img
                        className="image-order-manager__thumb"
                        src={url}
                        alt={`Gallery ${index + 1}`}
                      />
                      <div className="image-order-manager__actions">
                        <button
                          type="button"
                          className="image-order-manager__btn image-order-manager__btn--move"
                          onClick={() => moveImage(index, -1)}
                          disabled={index === 0}
                          title="Move left"
                        >
                          &#8592;
                        </button>
                        <button
                          type="button"
                          className="image-order-manager__btn image-order-manager__btn--move"
                          onClick={() => moveImage(index, 1)}
                          disabled={index === images.length - 1}
                          title="Move right"
                        >
                          &#8594;
                        </button>
                        {onSetMainImage && url !== mainImage && (
                          <button
                            type="button"
                            className="image-order-manager__btn image-order-manager__btn--main"
                            onClick={() => onSetMainImage(url)}
                            title="Set as main image"
                          >
                            &#9733;
                          </button>
                        )}
                        {onRemoveImage && (
                          <button
                            type="button"
                            className="image-order-manager__btn image-order-manager__btn--remove"
                            onClick={() => onRemoveImage(index)}
                            title="Remove image"
                          >
                            &times;
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
}

export default ImageOrderManager;
